import { Avatar } from '@mui/material';
import * as React from 'react';
import { Sizes } from '../@shared/palette';
import { User } from '../@shared/Models/Models';


type UserAvatarProps = {
    user: User | undefined;
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    size?: number
}

export const UserAvatar = ({ user, onClick, size }: UserAvatarProps) => {
    const stringToColor = React.useCallback((string: string) => {
        let hash = 0;
        let i;

        for (let i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }

        return color;
    }, [])

    const stringAvatar = React.useCallback((size: number) => {
        const name = user?.name ?? user?.email;
        const attrSX = {
            height: size + "px",
            width: size + "px",
            cursor: "pointer",
            fontSize: size > 50 ? Sizes.textLogo : Sizes.textPrimary,
        }

        if (!name) {
            return {
                sx: attrSX
            };
        }

        const splitedName = name.split(' ');

        return {
            sx: {
                bgcolor: stringToColor(name),
                ...attrSX
            },
            children: splitedName.length > 1 ? `${name.split(' ')[0][0]}${name.split(' ')[1][0]}` : name.split(' ')[0][0],
        };
    }, [stringToColor, user?.email, user?.name]);

    return <Avatar {...stringAvatar(size ?? 32)} onClick={onClick} alt={user?.name} src={user?.imageUrl} />
}
